import React from 'react';
import { Modal, Field } from '../../components/ui';
import { normaliseText } from '../../utils/helpers';
import { MODULES, MODULE_LABELS, ACTIONS, REPORT_BITS } from './useUsers';

// Shared Add-user / Permissions modal (same on desktop and mobile).
// Mobile (APK) add-member / permissions modal: full-screen, single column.
export default function UserFormMobile({ vm }) {
  const { isAdmin, modal, setModal, editing, saving, err, form, available, setF, setPerm, save, event, needEvent } = vm;

  const PermMatrix = () => (
    <div style={{ marginTop: 6 }}>
      <div className="muted" style={{ fontSize: 12, marginBottom: 6 }}>
        {form.IsAdmin ? 'Event Admins have full access — per-module permissions are ignored.' : 'Tick what this user may do per module.'}
      </div>
      <div className="table-wrap" style={{ opacity: form.IsAdmin ? 0.5 : 1, pointerEvents: form.IsAdmin ? 'none' : 'auto' }}>
        <table className="tbl">
          <thead><tr><th>Module</th><th>View</th><th>Add</th><th>Edit</th><th>Delete</th></tr></thead>
          <tbody>
            {MODULES.map(m => (
              <tr key={m}>
                <td>{MODULE_LABELS[m] || m}</td>
                {ACTIONS.map(a => {
                  const bit = `Can${m}${a}`;
                  return <td key={a}><input type="checkbox" checked={!!form.perms[bit]} onChange={e => setPerm(bit, e.target.checked)} /></td>;
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {REPORT_BITS.length > 0 && (
        <div style={{ marginTop: 10, fontSize: 13 }}>
          <strong>Reports:&nbsp;</strong>
          {REPORT_BITS.map(([bit, lbl]) => (
            <label key={bit} style={{ marginRight: 14, opacity: form.IsAdmin ? 0.5 : 1 }}>
              <input type="checkbox" checked={!!form.perms[bit]} disabled={form.IsAdmin}
                onChange={e => setPerm(bit, e.target.checked)} /> {lbl}
            </label>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <Modal
      fullScreen
      title={modal === 'add' ? 'Add Member' : `Permissions · ${editing?.Name || ''}`}
      onClose={() => setModal(null)}
      footer={<>
        <button className="btn light" onClick={() => setModal(null)}>Cancel</button>
        <button className="btn primary" disabled={saving || needEvent} onClick={save}>{saving ? 'Saving…' : 'Save'}</button>
      </>}
    >
      {/* Permissions are per-event — make the scope explicit. */}
      <div className="muted" style={{ fontSize: 12, marginBottom: 12 }}>
        {needEvent
          ? 'Pick an event in the top bar first — permissions are set per event.'
          : <>Permissions apply to event: <strong>{event?.EventName}</strong></>}
      </div>
      {modal === 'add' && (
        <>
          <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
            <button className={`btn sm ${form.addMode === 'existing' ? 'primary' : 'light'}`} onClick={() => setF('addMode', 'existing')}>Existing user</button>
            <button className={`btn sm ${form.addMode === 'new' ? 'primary' : 'light'}`} onClick={() => setF('addMode', 'new')}>New user</button>
          </div>
          {form.addMode === 'existing' ? (
            <Field label="Select user" type="select" value={form.UserId}
              options={available.map(u => ({ value: u.UserId, label: `${u.FullName || u.Name} · ${u.MobileNumber || ''}` }))}
              onChange={(v) => setF('UserId', v)} />
          ) : (
            <div>
              <Field label="Name" value={form.Name} onChange={(v) => setF('Name', normaliseText(v))} required />
              <Field label="Surname" value={form.Surname} onChange={(v) => setF('Surname', normaliseText(v))} />
              <Field label="Mobile Number" value={form.MobileNumber} onChange={(v) => setF('MobileNumber', v.replace(/\D/g, '').slice(0, 10))} required />
              <Field label="Password" value={form.Password} onChange={(v) => setF('Password', v)} required />
            </div>
          )}
        </>
      )}

      {/* Admin powers — promote to Event Admin + the permission matrix — are
          admin-only. A non-admin adds plain members (who can also add users). */}
      {isAdmin ? (
        <>
          <div style={{ marginTop: 6 }}>
            <Field label="Designation" value={form.Designation} onChange={(v) => setF('Designation', normaliseText(v))} />
            <label className="field" style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 4 }}>
              <input type="checkbox" checked={!!form.IsAdmin} onChange={(e) => setF('IsAdmin', e.target.checked)} style={{ width: 'auto' }} />
              Event Admin (full access)
            </label>
          </div>
          <PermMatrix />
        </>
      ) : (
        <div className="muted" style={{ fontSize: 12, marginTop: 10 }}>
          This person will be added as a <strong>member</strong> — they can sign in, add their own guests, and add more users.
        </div>
      )}
      {err && <div style={{ color: 'var(--danger)', fontSize: 13, marginTop: 10 }}>{err}</div>}
    </Modal>
  );
}
